import i18n from '@/utils/i18n';
import React from 'react';
import { AppPageLayout } from '@experiences/templates/app-page-layout';
import { CopilotChatContent } from '@/experiences/sales-portal/domain/copilot/screens/copilot-chat/containers/copilot-chat-content';
import { createStyles } from '@/contexts/theme-context';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesHubShellTemplate } from '@/experiences/sales-portal/templates/sales-hub-shell-template';
import { SalesPortalTabParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';
import { View } from 'react-native';

type Props = StackScreenProps<
  SalesPortalTabParams,
  typeof SALES_PORTAL_ROUTES.Copilot
>;

export const CopilotChatScreen: React.FC<Props> = () => {
  const [styles] = useStyles();

  return (
    <SalesHubShellTemplate>
      <AppPageLayout
        scroll={false}
        title={i18n.t('sales_portal.copilot.title')}
      >
        <View style={styles.content}>
          <CopilotChatContent />
        </View>
      </AppPageLayout>
    </SalesHubShellTemplate>
  );
};

const useStyles = createStyles((theme) => ({
  content: {
    flex: 1,
    paddingTop: theme.sk.spacing.spaceMedium,
  },
}));
